
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class HsnMasterGrid extends Serenity.EntityGrid<HsnMasterRow, any> {
        protected getColumnsKey() { return HsnMasterColumns.columnsKey; }
        protected getDialogType() { return HsnMasterDialog; }
        protected getIdProperty() { return HsnMasterRow.idProperty; }
        protected getInsertPermission() { return HsnMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return HsnMasterRow.localTextPrefix; }
        protected getService() { return HsnMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}